/*
 * Кнопка в стиле ОТВЕТО. Компактный порт otveto/apps/web/src/components/common/ui/Button.pcss:
 * там 709 строк на двенадцать вариантов, здесь оставлены пять, которые реально нужны формам.
 * Матрица цветов — на тех же переменных --btn-*, так что добавить остальные варианты
 * потом можно копипастой из оригинала.
 */

.root {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	border: 1px solid transparent;
	border-radius: var(--Border-radius-S);
	cursor: pointer;
	font-family: inherit;
	font-size: 16px;
	font-weight: 500;
	line-height: 120%;
	white-space: nowrap;
	text-decoration: none;
	transition:
		background-color 0.2s ease-in-out,
		border-color 0.2s ease-in-out,
		color 0.2s ease-in-out;
}

.root:disabled {
	cursor: default;
}

.fullWidth {
	width: 100%;
}

/* Размеры */
.extraSmall {
	min-height: 40px;
	padding: 0 16px;
	font-size: 14px;
}

.small {
	min-height: 44px;
	padding: 0 20px;
	font-size: 14px;
}

.medium {
	min-height: 48px;
	padding: 0 24px;
}

.large {
	min-height: 56px;
	padding: 0 28px;
	border-radius: var(--Border-radius-M);
}

/* primary */
.primary {
	background: var(--btn-primary-body);
	color: var(--btn-primary-label);
}

.primary:hover:not(:disabled) {
	background: var(--btn-primary-body-hover);
}

.primary:disabled {
	background: var(--btn-primary-body-disable);
	color: var(--btn-primary-label-disable);
}

/* secondary */
.secondary {
	background: var(--btn-secondary-body);
	color: var(--btn-secondary-label);
}

.secondary:hover:not(:disabled) {
	background: var(--btn-secondary-body-hover);
}

.secondary:disabled {
	background: var(--btn-secondary-body-disable);
	color: var(--btn-secondary-label-disable);
}

/* tertiary */
.tertiary {
	background: var(--btn-tertiary-body);
	color: var(--btn-tertiary-label);
}

.tertiary:hover:not(:disabled) {
	background: var(--btn-tertiary-body-hover);
	color: var(--btn-tertiary-label-hover);
}

.tertiary:disabled {
	background: var(--btn-tertiary-body-disable);
	color: var(--btn-tertiary-label-disable);
}

/* outlineSecondary */
.outlineSecondary {
	background: transparent;
	border-color: var(--btn-outline-secondary-border);
	color: var(--btn-outline-secondary-label);
}

.outlineSecondary:hover:not(:disabled) {
	color: var(--btn-outline-secondary-label-hover);
	border-color: var(--border-main-primary);
}

.outlineSecondary:disabled {
	border-color: var(--btn-outline-secondary-border-disabled);
	color: var(--btn-outline-secondary-label-disable);
}

/* error — мягкий красный, как в otveto: сплошной красный в ките не используется.
   Рамка нужна на светлой подложке: без неё кнопка сливается с фоном карточки
   и не читается как кнопка. */
.error {
	background: var(--btn-error-body);
	color: var(--btn-error-label);
	/* Размер не поедет: базовая кнопка уже держит прозрачную рамку в 1px */
	border-color: var(--danger-tertiary);
}

.error:hover:not(:disabled) {
	background: var(--btn-error-body-hover);
	border-color: var(--danger-secondary);
}

.error:disabled {
	background: var(--btn-tertiary-body-disable);
	color: var(--btn-tertiary-label-disable);
	border-color: transparent;
}

/* ghostPrimary */
.ghostPrimary {
	background: transparent;
	color: var(--btn-ghost-primary-label);
	padding-left: 0;
	padding-right: 0;
}

.ghostPrimary:hover:not(:disabled) {
	color: var(--btn-ghost-primary-label-hover);
}

.ghostPrimary:disabled {
	color: var(--btn-ghost-primary-label-disable);
}

/* Иконка и текст: отступ между ними и центрирование по вертикали. Живёт здесь,
   а не на .root, потому что для кнопки содержимое — один ребёнок, а не два */
.content {
	display: inline-flex;
	align-items: center;
	gap: 8px;
}

/* Загрузка: текст гасим прозрачностью, чтобы кнопка не меняла ширину */
.loadingLabel {
	opacity: 0;
}

.spinner {
	position: absolute;
	display: inline-flex;
}

.loadingWrap {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
